import _ from 'lodash'
import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import NotAllowed from './NotAllowed';

const ProtectedRoute = ({ component: Component, check, ...rest }) => (
  <Route {...rest} render={props => {
    const _check = check(rest.path);

    if (_.isPlainObject(_check)) {
      const { pass, redirect } = _check
      if (!pass && !redirect) {
        return <NotAllowed />
      }
      return pass 
        ? (<Component {...props}/> ) 
        : (<Redirect to={{ pathname: redirect, state: { from: props.location }}}/>)
    }
    return  _check ? 
      (<Component {...props}/> ) :
      (<Redirect to={{ pathname: '/login', state: { from: props.location }}}/>)
  }}/>
)


export default ProtectedRoute;



// WEBPACK FOOTER //
// ./src/components/Auth/ProtectedRoute.js